import Layout from '@/layout'

const SalesRouter = {
  path: '/Sales',
  component: Layout,
  redirect: 'noredirect',
  name: 'Sales',
  meta: {
    title: 'Sales',
    icon: 'daohang-ziliaoguanli',
    roles: []
  },
  children: [
    {
      path: 'CreditBusinessManage',
      component: () => import('@/views/cargo/v0/Sales/creditBusinessManage'),
      name: 'CreditBusinessManage',
      meta: { title: '信控业务管理' },
      roles: ['module_CreditBusinessManage']
    },
    {
      path: 'SalesQuery',
      component: () => import('@/views/cargo/v0/Sales/salesQuery'),
      name: 'SalesQuery',
      meta: { title: '销售查询' },
      roles: ['module_SalesQueryModule']
    },
    {
      path: 'MyCustomer',
      component: () => import('@/views/cargo/v0/Sales/myCustomer'),
      name: 'MyCustomer',
      meta: { title: '我的客户' },
      roles: ['module_CRMMyCustomerManager']
    },
    {
      path: 'MyGroupCustomer',
      component: () => import('@/views/cargo/v0/Sales/myGroupCustomer'),
      name: 'MyGroupCustomer',
      meta: { title: '本组客户' },
      roles: ['module_CRMMyGroupCustomerManager']
    },
    {
      path: 'ShareCustomer',
      component: () => import('@/views/cargo/v0/Sales/shareCustomer'),
      name: 'ShareCustomer',
      meta: { title: '客户公海' },
      roles: ['module_CRMShareCustomerManager']
    },
    {
      path: 'EventManager',
      component: () => import('@/views/cargo/v0/Sales/eventManager'),
      name: 'EventManager',
      meta: { title: '事件管理' },
      roles: ['module_CRMEventManager']
    },
    {
      path: 'RemoteBooking',
      component: () => import('@/views/cargo/v0/Sales/remoteBooking'),
      name: 'RemoteBooking',
      meta: { title: '远程订舱' },
      roles: ['module_RemoteBooking']
    },
    {
      path: 'OpenSeaCabinSpace',
      component: () => import('@/views/cargo/v0/Sales/openSeaCabinSpace'),
      name: 'OpenSeaCabinSpace',
      meta: { title: '公海舱位' },
      roles: ['module_OpenSeaCabinSpace']
    },
    {
      path: 'SalesQuery2Sale',
      component: () => import('@/views/cargo/v0/Sales/salesQuery2Sale'),
      name: 'SalesQuery2Sale',
      meta: { title: '销售查询-销售部' },
      roles: ['module_SalesQuery2Sale']
    },
    {
      path: 'SalesQuery2Csr',
      component: () => import('@/views/cargo/v0/Sales/salesQuery2Csr'),
      name: 'SalesQuery2Csr',
      meta: { title: '销售查询-海外部' },
      roles: ['module_SalesQuery2Csr']
    },
    {
      path: 'CRMRecoveryCustomerManager',
      component: () => import('@/views/cargo/v0/Sales/crmRecoveryCustomerManager'),
      name: 'CRMRecoveryCustomerManager',
      meta: { title: '客户回收站' },
      roles: ['module_CRMRecoveryCustomerManager']
    },
    {
      path: 'CRMScheduleCustomerManager',
      component: () => import('@/views/cargo/v0/Sales/crmScheduleCustomerManager'),
      name: 'CRMScheduleCustomerManager',
      meta: { title: '待办事项' },
      roles: ['module_CRMScheduleCustomerManager']
    },
    {
      path: 'CRMSetting',
      component: () => import('@/views/cargo/v0/Sales/crmSetting'),
      name: 'CRMSetting',
      meta: { title: 'CRM设置' },
      roles: ['module_CRMSetting']
    }
  ]
}

export default SalesRouter
